import type { FindSavedASTResponseType } from 'src/api/generated/touring/types';
import type { QueryBuilderAstNodeType } from '@common';

export const mapFindSavedASTResponseType = (
  api: FindSavedASTResponseType
): QueryBuilderAstNodeType => api.data.ast as QueryBuilderAstNodeType;
